function scrollInputToTop() {
  const inputField = document.getElementById("scrollableInput");
  if (inputField) {
    inputField.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}

export default scrollInputToTop;
